import { H4 } from '#app/ui/components/typography/h4'
import { cn } from '#app/utils/tailwind-merge.ts'

/**
 * The card treatment used across the marketing sections: a filled surface with
 * a hairline border and no shadow. Works in both light and inverted contexts
 * because every token flips under `.dark`.
 */
export const Card = ({
	title,
	body,
	className,
}: {
	title: string
	body: string
	className?: string
}) => (
	<div
		className={cn(
			'flex h-full flex-col rounded-2xl border border-hairline bg-surface p-6',
			className,
		)}
	>
		<H4 className="mt-0 text-base normal-case">{title}</H4>
		<p className="mt-2 text-sm leading-relaxed text-muted-600">{body}</p>
	</div>
)
